// extracted by mini-css-extract-plugin
module.exports = {"imgDesktop":"FooterVito_imgDesktop_3YMKh","imgMobile":"FooterVito_imgMobile_3IPyv"};